<template>
  <div class="fixed-content">
    <div class="fixed-wrap">
      <div
        class="
          header-row
        ">
        <div
          class="
            header-left
          ">
          <el-select
            class="
              limit-select
            "
            size="small"
            :value="
              pager.limit
            "
            :disabled="
              loader
            "
            @change="
              (limit) => $emit(
                'limit-change', limit
              )
            ">
            <el-option
              v-for="
                size in pageSizes
              "
              :key="size"
              :label="
                `${size} รายการ`
              "
              :value="size"
            />
          </el-select>
          <div
            class="
              tags-slot
            ">
            <slot name="tags" />
          </div>
        </div>
        <div
          class="
            header-right
          ">
          <label
            v-if="
              total > 0
            "
            class="
              total-label
            ">
            พบ {{ total || 0 }} รายการ
          </label>
          <div
            class="
              actions-slot
            ">
            <slot name="actions" />
          </div>
        </div>
      </div>
      <div
        :id="
          'table-wrap'
        "
        class="
          table-wrap
        ">
        <!-- <section v-if="loader">

        </section> -->
        <section
          v-if="
            !loader && total == 0
          "
          class="empty">
          <img
            src="@/assets/images/admin/empty.png"
          />
          <p>
            <b class="unknown">
              ไม่พบข้อมูล
            </b>
          </p>
        </section>
        <table
          v-else>
          <thead>
            <tr>
              <th
                v-for="
                  (group, i) in groups
                "
                :key="i"
                class="
                  group-end
                "
                :colspan="
                  groupFields[group].length
                "
                :rowspan="
                  i == groups.fixed ? 2 : null
                ">
                {{ groupLabels[group] }}
              </th>
            </tr>
            <tr class="sub-header">
              <th
                v-for="
                  (key, i) in keys
                "
                :key="i"
                :class="
                  headerClass(key)
                ">
                {{ headerLabels[key] }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="
                (row, i) in rows
              "
              :key="i"
              :class="
                rowClass(i)
              ">
              <td
                v-for="
                  (value, r) in row
                "
                :key="r"
                :class="
                  cellClass(keys[r])
                ">
                <el-tag
                  v-if="
                    isStatusKey(keys[r]) && value && !isBlank(keys[r], i)
                  "
                  class="
                    status-tag
                  "
                  size="small"
                  :type="
                    statusType(value)
                  ">
                  {{ value }}
                </el-tag>
                <el-button
                  v-else-if="
                    linkTo(keys[r], i) && value !== '-' && !isBlank(keys[r], i)
                  "
                  type="text"
                  class="
                    text-link
                  "
                  @click="
                    () => openLink(keys[r], i)
                  ">
                  {{ cellValue(keys[r], value, i) }}
                </el-button>
                <el-button
                  v-else-if="
                    isDetailKey(keys[r], value) && value && !isBlank(keys[r], i)
                  "
                  type="text"
                  class="
                    text-link
                  "
                  @click="
                    () => openDetail(keys[r], value)
                  ">
                  ดูรายละเอียด
                </el-button>
                <el-button
                  v-else-if="
                    imageTo(keys[r], i) && !isBlank(keys[r], i)
                  "
                  type="text"
                  class="
                    text-link
                  "
                  @click="
                    () => openImage(keys[r], i)
                  ">
                  {{ cellValue(keys[r], value, i) }}
                </el-button>
                <span
                  v-else
                  :class="{
                    'text-pending': isPendingProject(keys[r], value)
                  }">
                  {{ cellValue(keys[r], value, i) }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <section
        v-if="
          total > 0
        "
        class="
          pagination-wrap
        ">
        <div class="pagination">
          <el-pagination
            :background="true"
            :layout="
              'prev, pager, next'
            "
            :pager-count="5"
            :current-page="
              pager.page
            "
            :page-size="
              pager.limit
            "
            :total="
              total || 0
            "
            :disabled="
              loader
            "
            @current-change="
              (page) => $emit(
                'page-change', page
              )
            "
          />
        </div>
      </section>
    </div>

    <SubsReportDetailModal
      :open.sync="
        detail.open
      "
      :title="
        detail.title
      "
      :content="
        detail.content
      "
      :image="
        detail.image
      "
    />
  </div>
</template>

<script lang="js">

// Common
import { SubsReportMapperCommon as MapperCommon } from '@/features/subscribers-report/common/subs-report-mapper.common'
import { SubsReportFilterCommon as FilterCommon } from '@/features/subscribers-report/common/subs-report-filter.common'

// Components
import SubsReportDetailModal from '@/features/subscribers-report/components/SubsReportDetailModal'

// Field props
const {
  groups,
  groupLabels,
  groupFields,
  headerLabels,
  keys,
  labels,
} = MapperCommon

export default {
  components: {
    SubsReportDetailModal,
  },
  props: {
    loader: {
      type   : Boolean,
      default: false
    },
    total: {
      type   : Number,
      default: 0
    },
    pager: {
      type   : Object,
      default: () => FilterCommon.pager()
    },
    rows: {
      type   : Array,
      default: () => []
    },
    items: {
      type   : Array,
      default: () => []
    }
  },
  data() {
    return {
      groups,
      groupLabels,
      groupFields,
      headerLabels,
      keys,
      pageSizes: [
        30, 50, 100
      ],
      detail: {
        open   : false,
        title  : null,
        content: null,
        image  : null,
      },
    }
  },
  computed: {
    groupEndKeys() {
      return Object.values(this.groupFields).map(
        fields => fields[fields.length - 1]
      )
    },
    userGroupSpans() {
      return this.buildSpans(this.userKey)
    },
    subsGroupSpans() {
      return this.buildSpans(this.subsKey)
    },
  },
  watch: {
    loader(value, prev) {
      if (!value && prev) {
        this.resetScroll()
      }
    },
    'detail.open': function(open) {
      if (!open) {
        this.detail.image = null
      }
    },
  },
  methods: {
    resetScroll() {

      // Table wrap
      const el = (
        document.getElementById('table-wrap')
      )

      // Validate table
      if (!el) return

      // Reset scroll
      el.scrollTop  = 0
      el.scrollLeft = 0
    },
    isEndGroup(key) {
      return this.groupEndKeys.includes(key)
    },
    isStatusKey(key) {

      // Status keys
      const status = [
        labels.actualStatus,
        labels.txnStatus,
        labels.billingStatus,
      ]

      return status.includes(key)
    },
    isDetailKey(key, value) {

      // Detail keys
      const detail = [
        labels.address,
        labels.receiptInfo,
      ]

      // Validate detail key
      if (!detail.includes(key)) return false

      // Pending project placeholder
      if (this.isPendingProject(key, value)) return false

      return true
    },
    isPendingProject(key, value) {

      // Pending project keys
      const pending = [
        labels.address,
        labels.projectName,
      ]

      return (
        pending.includes(key) && value === 'รอเลือกผูกบ้านที่ต้องการใช้งาน'
      )
    },
    openDetail(key, value) {
      this.detail = {
        open   : true,
        title  : this.headerLabels[key],
        content: value,
        image  : null,
      }
    },
    imageTo(key, i) {
      return (
        MapperCommon.imageTo(key, this.items[i])
      )
    },
    openImage(key, i) {
      this.detail = {
        open   : true,
        title  : this.headerLabels[key],
        content: null,
        image  : this.imageTo(key, i),
      }
    },
    cellClass(key) {
      return {
        'group-end': this.isEndGroup(key),
        'status'   : this.isStatusKey(key),
        'truncate' : this.isTruncateField(key),
      }
    },
    isTruncateField(key) {
      return key === labels.taxId
    },
    headerClass(key) {
      return {
        'hidden'   : this.isHiddenHeader(key),
        'group-end': this.isEndGroup(key)
      }
    },
    rowClass(i) {
      return {
        'group-start'   : this.isGroupStart(i),
        'group-continue': this.isGroupContinue(i)
      }
    },
    isBlankField(key) {
      return (
        MapperCommon.blankFields.includes(key)
      )
    },
    isUserField(key) {
      return (
        this.groupFields.user.includes(key) || this.groupFields.fixed.includes(key)
      )
    },
    isBlank(key, i) {

      // Validate blank field
      if (!this.isBlankField(key)) return false

      return this.isUserField(key)
        ? !this.isRowStart(i)
        : !this.isSubsRowStart(i)
    },
    linkTo(key, i) {
      return (
        MapperCommon.linkTo(key, this.items[i])
      )
    },
    openLink(key, i) {

      // Target route
      const route = this.linkTo(key, i)

      // Validate route
      if (!route) return

      // Get link
      const { href } = this.$router.resolve(route)

      // Open link
      window.open(href, '_blank')
    },
    isCurrencyField(key) {
      return (
        MapperCommon.currencyFields.includes(key)
      )
    },
    userKey(i) {

      // Validate item
      if (!this.items[i]) return null

      // Item props
      const { user } = this.items[i]

      return user.userId
    },
    subsKey(i) {

      // Validate item
      if (!this.items[i]) return null

      // Item props
      const { subscription } = this.items[i]

      return (
        `${this.userKey(i)}-${subscription.subscriptionId}`
      )
    },
    buildSpans(keyOf) {

      // Rowspan per row
      const spans = []

      // Group start index
      let start = 0

      // Group mapper
      const grouper = (_, i) => {

        // Validate group
        const isOther = (
          i === 0 || keyOf(i) !== keyOf(i - 1)
        )

        // Rowspan count
        if (isOther) {
          start = i
        } else {
          spans[start] += 1
        }

        // Rowspan start
        spans[i] = isOther ? 1 : 0
      }

      // Loop rows
      this.rows.forEach(grouper)

      return spans
    },
    isRowStart(i) {
      return (
        this.userGroupSpans[i] !== 0
      )
    },
    isSubsRowStart(i) {
      return (
        this.subsGroupSpans[i] !== 0
      )
    },
    isGroupStart(i) {
      return (
        i > 0 && this.isRowStart(i)
      )
    },
    isGroupContinue(i) {
      return (
        i + 1 < this.rows.length && !this.isRowStart(i + 1)
      )
    },
    isHiddenHeader(key) {
      return (
        this.groupFields.fixed.includes(key)
      )
    },
    cellValue(key, value, i) {
      
      // Validate blank field
      if (this.isBlank(key, i)) {
        return ''
      }

      // Validate currency field
      if (this.isCurrencyField(key)) {
        return MapperCommon.currency(value)
      }

      // Validate pending project
      if (this.isPendingProject(key, value)) {
        return 'รอเลือกบ้าน'
      }

      // Filter keys
      switch (key) {

        // Gender field
        case labels.gender: {
          return MapperCommon.gender(value)
        }

        // Appointment remark flag
        case labels.hasRemark: {
          return value ? 'นัดหมาย' : ''
        }

        // Other fields
        default: {
          return value
        }
      }
    },
    statusType(value) {
      return MapperCommon.status(value)
    },
  },
}

</script>

<style lang="css" scoped>

.fixed-content {
  height    : 100%;
  min-height: 0;
  overflow  : auto;
}

.fixed-wrap {
  display         : flex;
  flex-direction  : column;
  gap             : var(--size-md);
  width           : 100%;
  max-height      : 100%;
  padding         : var(--size-lg);
  border-radius   : var(--size-md);
  background-color: white;
}

.header-row {
  display        : flex;
  align-items    : center;
  justify-content: space-between;
  gap            : var(--size-md);
  padding        : 0;
  background     : none;
  border         : none;
}

.header-left {
  display    : flex;
  flex       : none;
  align-items: center;
  gap        : var(--size-sm);
}

.limit-select {
  flex : none;
  width: 9rem;
}

.tags-slot:empty,
.actions-slot:empty {
  display: none;
}

.header-right {
  display    : flex;
  flex       : none;
  align-items: center;
  gap        : var(--size-md);
}

.total-label {
  margin-bottom: 0 !important;
  white-space  : nowrap;
}

.table-wrap {
  flex                   : 1;
  min-height             : 0;
  overflow               : auto;
  border-top-left-radius : var(--size-md);
  border-top-right-radius: var(--size-md);
  max-height             : 70svh;
}

.pagination-wrap {
  display        : flex;
  flex           : none;
  align-items    : center;
  justify-content: flex-end;
  gap            : var(--size-md);
}

.pagination {
  display    : flex;
  align-items: center;
  gap        : var(--size-md);
}

table .hidden {
  display: none;
}

table {
  width          : 100%;
  overflow       : auto;
  border-collapse: separate;
  border-spacing : 0;
  font-size      : 1rem;
}

table th {
  width    : auto;
  min-width: 9rem;
}

table td {
  vertical-align: top;
}

thead {
  position  : sticky;
  top       : 0;
  z-index   : 2;
  background: white;
}

table tr.sub-header {
  font-size: 1rem;
}
table tr.sub-header th {
  font-weight: normal;
}

table th, table td {
  padding      : var(--size-xs) var(--size-sm);
  border-bottom: 1px solid #dfdedb;
  white-space  : nowrap;
}

table tbody tr.group-start td {
  border-top: 1px solid #dfdedb;
}

table tbody tr.group-continue td {
  border-bottom: 1px dashed #d8d8d8;
}

.status-tag {
  border-radius: 1rem;
}

table th.group-end,
table td.group-end {
  border-right: 1px solid #dfdedb;
}

table th:first-child,
table td:first-child {
  text-align  : center;
  position    : sticky;
  left        : 0;
  z-index     : 1;
  border-right: 1px solid #dfdedb;
}

table td:first-child {
  max-width    : 10rem;
  overflow     : hidden;
  text-overflow: ellipsis;
  background   : white;
}

table td.truncate {
  max-width    : 10rem;
  overflow     : hidden;
  text-overflow: ellipsis;
}

table th, table th:first-child {
  color     : #7A776F;
  background: #FBFAF8;
}

thead th:first-child {
  z-index: 3;
}

table tbody {
  width   : 100%;
  overflow: auto;
}

.text-link {
  font-size: 1rem;
  padding  : 0;
}

.text-pending {
  color: #909399;
}

@media screen and (max-width: 1024px) {
  
  .header-left, .header-right {
    gap: var(--size-xs);
    flex-direction: column;
  }
  .header-left {
    align-items: start;
  }
  .header-right {
    align-items: end;
  } 
}

@media screen and (max-width: 640px) {

  .header-row, .header-left {
    flex-direction: column;
  }

  .header-left, .header-right {
    width: 100%;
  }

  .header-left {
    width      : 100%;
    align-items: end;
  }
  .header-right {
    flex-direction : row;
    align-items    : center;
    justify-content: space-between;
    
  } 

  table th:first-child,
  table td:first-child {
    position    : static;
    border-right: none;
  }
}

</style>
